import { render, staticRenderFns } from "./ChildBackupYN.vue?vue&type=template&id=50705c46"
import script from "./ChildBackupYN.vue?vue&type=script&lang=js"
export * from "./ChildBackupYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports